import {Component, Input} from '@angular/core';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'empty-result-message',
    templateUrl: './empty-result-message.component.html',
    styleUrls: ['./empty-result-message.component.scss']
})
export class EmptyResultMessageComponent {

    /**
     * Is current service unavailable
     */
    @Input() isServiceUnavailable: boolean = false;

    /**
     * Is data loading
     */
    @Input() isLoading = false;

    /**
     * Defines whether was any non-empty result
     * after component initialization
     */
    isWasResult = false;

    /**
     * Is current table result empty
     */
    isEmptyResult = true;

    constructor(private urlService: UrlService) {
    }

    /**
     * Receives current table content state
     * @param value
     */
    @Input()
    set isEmpty(value: boolean) {
        if (!value) {
            this.isWasResult = true;
        }

        this.isEmptyResult = value;
    }

    /**
     * Is result filtered
     */
    get isFiltered(): boolean {
        return this.isWasResult || !!this.urlService.queryParams.query;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/empty-result-message/empty-result-message.component.ts